import {
  ICaseAction,
  IDataAPICaseComment,
  UpdateCaseActionRequest
} from "@/types/casesFrontendTypes";
import { createServerEndpoint } from "@/utils/functions";
import axios from "axios";

const state = () => ({
  currentValue: [] as ICaseAction[]
});
const getters = {
  latest(state: any): ICaseAction | null {
    if (state.currentValue.length <= 0) return null;
    const lastItemIndex = state.currentValue.length - 1;
    return state.currentValue[lastItemIndex];
  }
};

const mutations = {
  SET_CURRENT_VALUE(state: any, payload: ICaseAction[]) {
    state.currentValue = payload;
  }
};

const actions = {
  async FETCH_CURRENT_VALUE({ commit }: any, id: string) {
    const endpointRaw = createServerEndpoint("/api/cases/{case_id}/actions");
    const endpoint = endpointRaw.replace("{case_id}", id);

    try {
      const { data } = await axios.get<ICaseAction[]>(endpoint);
      commit("SET_CURRENT_VALUE", data);
    } catch (error) {
      console.error(error);
      commit("SET_CURRENT_VALUE", []); // Set an empty array in case of an error
    }
  },

  async UPDATE_CASE({ dispatch }: any, input: UpdateCaseActionRequest) {
    const { id, ...payload } = input;
    const endpointRaw = createServerEndpoint("/api/cases/{case_id}/comment");
    const endpoint = endpointRaw.replace("{case_id}", id);

    try {
      const { data } = await axios.post<IDataAPICaseComment>(endpoint, payload);
      // Optionally refresh the current value after the update
      await dispatch("FETCH_CURRENT_VALUE", id);

      // Update the URL to include the "comments" tab
      const url = new URL(location.href);
      url.searchParams.set("tab", "comments");
      location.assign(url.search);
    } catch (error) {
      console.error("Error updating case:", error);
    }
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
